import { useMutation } from "@tanstack/react-query";
import { toast } from "sonner";
import { updateClient } from "./api";
import { invalidateAllQueries } from "utils/utils";

function buildPayload(values) {
  if (!values || typeof values !== "object") return {};

  const { ...rest } = values;
  return {
    ...Object.fromEntries(
      Object.entries(rest).filter(
        ([_, v]) => v !== "" && v !== undefined && v !== null
      )
    ),
  };
}

export function useUpdateClient() {
  return useMutation({
    mutationFn: async ({ item, clientId }) => {
      const payload = buildPayload(item);
      const response = await updateClient({ item: payload, clientId });
      return response;
    },
    onSuccess: () => {
      toast.success("Client Updated Successfully");
      invalidateAllQueries();
    },
    onError: (error) => {
      toast.error(error.message);
      console.log(error.message);
    },
  });
}
